<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header *ngIf="!leadAdd" [height]="'160px'" background="url(assets/images/headers/pattern-3.png)"
        [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs *ngIf="!leadAdd" [url]="leadId==0?'lead,Add Lead':'lead,Edit Lead'"
            [currentPage]="leadId==0?'Lead,Add Lead':'Lead,Edit Lead'" [header]="'primary'">
        </calsoft-breadcrumbs>


        <div *ngIf="!leadAdd && leadId == 0" fxLayout="column" fxLayoutGap="24px" fxFlex>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space flex-1" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" [attr.guide]="'add-edit-product-header-1' + '__' + sanitizeUrl(url)"
                            fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-edit-product-back-btn' + '__' + sanitizeUrl(url)"
                                (click)="back()" matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button> {{title}}
                        </div>
                    </div>
                    <div class="content" fxLayout="column">
                        <div class="result" fxLayout="column">
                            <div class="container">
                                <div id="content">
                                    <div class="products-padding">
                                        <div class="premium-form-section" [formGroup]="firstFormGroup">
                                            <!-- <div class="section-header" fxLayout="row" fxLayoutAlign="start center"
                                                fxLayoutGap="16px">
                                                <div class="header-icon-box">
                                                    <mat-icon>tune</mat-icon>
                                                </div>
                                                <div class="header-text-group">
                                                    <h3 class="section-title">Create Lead</h3>
                                                    <span class="section-subtitle">Initial configuration for your new
                                                        lead</span>
                                                </div>
                                            </div> -->

                                            <div class="section-body">
                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                                                    <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Attribute Set</mat-label>
                                                        <mat-select
                                                            [attr.guide]="'add-edit-product-sel-1' + '__' + sanitizeUrl(url)"
                                                            formControlName="attributeSet"
                                                            [disableOptionCentering]="true" required #singleSelect>
                                                            <mat-option>
                                                                <ngx-mat-select-search name="Attribute Search"
                                                                    ngDefaultControl
                                                                    [formControl]="attributeFilterControl"
                                                                    placeholderLabel="Attribute Search"
                                                                    [preventHomeEndKeyPropagation]="true"
                                                                    noEntriesFoundLabel="No data found">
                                                                </ngx-mat-select-search>
                                                            </mat-option>
                                                            <mat-option
                                                                [attr.guide]="'add-edit-product-opt-' + i + '__' + sanitizeUrl(url)"
                                                                *ngFor="let item of filteredAttributeList; let i=index;"
                                                                [value]="item.attributeSetId">
                                                                {{item.attributeSetName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.attributeSet">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>

                                                <div fxLayoutAlign="end center">
                                                    <button [attr.guide]="'add-edit-product-create' + '__' + sanitizeUrl(url)" [disabled]="textAdd !='Create'"
                                                        (click)="getAttributeGroup()" mat-flat-button
                                                        class="btn-premium primary">
                                                        <mat-icon *ngIf="textAdd =='Create'">add_circle</mat-icon>
                                                        <!-- <mat-spinner *ngIf="textAdd !='Create'" color="accent"
                                                            diameter="20"></mat-spinner> -->
                                                        <span>{{textAdd}}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card flex-1" fxFlex fxLayout="column" *ngIf="leadAdd">

            <mat-drawer-container fxFlex>

                <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" (openedChange)="drawerChange($event)"
                    [opened]="drawerOpen$ | async" class="drawer-premium" position="start">

                    <div class="sidenav-inner-premium" fxFlex fxLayout="column">
                        <div class="sidenav-header-premium" fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-edit-product-back' + '__' + sanitizeUrl(url)" (click)="back()" mat-icon-button class="back-btn-premium">
                                <mat-icon>chevron_left</mat-icon>
                            </button>
                            <span class="header-title-premium">{{title}}</span>
                        </div>

                        <div class="flex-auto  overflow-hidden">

                            <calsoft-scrollbar class="flex-auto">
                                <mat-nav-list class="nav-list-premium">
                                    <mat-list-item [attr.guide]="'add-edit-product-nav-' + i + '__' + sanitizeUrl(url)"
                                        *ngFor="let item of regConfig; let i = index"
                                        (click)="get(item.attributeGroupName,i,item)" class="nav-item-premium"
                                        [class.active-item]="item.attributeGroupName == groupName">

                                        <div class="nav-item-content" fxLayout="row" fxLayoutAlign="start center"
                                            fxLayoutGap="12px">
                                            <span class="nav-label">{{ item.attributeGroupName }}</span>

                                            <span fxFlex></span>

                                            <!-- Validation Status -->
                                            <div class="status-indicator"
                                                *ngIf="invalidMap.get(i) == undefined || !checkValidataion(i)">
                                                <mat-icon class="status-icon success">check_circle</mat-icon>
                                            </div>

                                            <div class="status-indicator"
                                                *ngIf="invalidMap.get(i) != undefined && checkValidataion(i)">
                                                <mat-icon class="status-icon error">error</mat-icon>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </mat-nav-list>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer>
                <mat-drawer-content>
                    <div class="chat-inner-container" fxFlex fxLayout="column">
                        <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">
                            <button fxHide.gt-sm type="button" mat-icon-button (click)="openDrawer()"
                                style="margin-right: 8px;">
                                <mat-icon>menu</mat-icon>
                            </button>

                            <!-- <span class="toolbar-title">{{title}}</span> -->

                            <span fxFlex></span>

                            <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
                                <button [attr.guide]="'add-edit-product-audit' + '__' + sanitizeUrl(url)" mat-icon-button *ngIf="leadId != 0" (click)="audit()" matTooltip="Audit Log">
                                    <mat-icon>calendar_today</mat-icon>
                                </button>
                                <!-- 
                             <button [disabled]="text !='Save'" (click)="save()" mat-raised-button
                                class="deal-save-btn">
                                <mat-spinner *ngIf="text != 'Save'" color="accent" diameter="20"></mat-spinner>
                                <span>{{text}}</span>
                            </button> -->
                                <button [attr.guide]="'add-edit-product-save' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'" (click)="save()" mat-raised-button>
                                    {{text}}
                                    <mat-icon *ngIf="text !='Save' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>
                        </div>

                        <div class="flex-auto">
                            <calsoft-scrollbar #tabsContentRef class="p-4  flex-auto">
                                <ng-container *ngIf="regConfig?.length > 0">
                                    <div>
                                        <div class="premium-form-section">
                                            <div class="section-header">
                                                <h3 class="section-title">{{groupName}}</h3>
                                            </div>
                                            <div class="section-body">
                                                <div class="result-grid" fxLayout="column">
                                                    <div *ngFor="let field of regConfig[defalutValue]['eavEntityAttribute'];"
                                                        [attr.guide]="'add-edit-product-field-' + field['eavAttribute'].attributeCode + '__' + sanitizeUrl(url)">
                                                        <ng-container dynamicField [field]="field['eavAttribute']"
                                                            [data]="data" [group]="form">
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </ng-container>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>